// Get the user's time zone
const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

// Set the user's time zone in a cookie
document.cookie = `user_time_zone=${userTimeZone}; path=/; samesite=Lax; secure`;
